const once = require('./once');

module.exports = function ({fn, rp$, window, label}) {
	if (window.__PLUGIN_READY_QUEUE) {
		window.__PLUGIN_READY_QUEUE.push(fn);
	} else {
		rp$(once(fn));
	}
};
